import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useCallback, useMemo } from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import type { Variant } from '~/@types/product'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import variantsToOptions from '~/components/UI/ProductHeader/ProductStickyCta/variantsToOptions'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductOptionsProps {
  variants?: Variant[]
  active?: boolean
  onClick?: () => void
}

function ProductOptions({ variants, active, onClick }: ProductOptionsProps) {
  const router = useRouter()
  const options = useMemo(() => variantsToOptions(variants), [variants])

  const selectStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  const handleOnClick = useCallback(
    (e) => {
      onClick()
      router.push(
        {
          pathname: router.pathname,
          query: {
            ...router?.query,
            variant: e,
          },
        },
        undefined,
        { shallow: true },
      )
    },
    [router],
  )

  if (!options) return null

  return (
    <div className={cx(css.ProductOptions, { active })}>
      {options.map(({ value, label }) => {
        const isSelected = router?.query?.variant === value

        return (
          <div
            key={value}
            className={cx(css.option, selectStyle)}
            onClick={() => handleOnClick(value)}>
            <span className={cx(css.text, { isSelected })}>{label}</span>
          </div>
        )
      })}
    </div>
  )
}

export default ProductOptions
